import * as React from 'react'
import * as ReactDOM from 'react-dom'
import Sections from './components/section'
import Map from './components/map'
import ThankYou from './components/thank-you'
import {Base64 } from 'js-base64';
import {decode} from 'html-entities';

class WidgetContactUs extends elementorModules.frontend.handlers.Base {
	getDefaultSettings() {
		return {
			selectors: {
				app: '.ecf-contact-us',
			},
		};
	}

	getDefaultElements() {
		const selectors = this.getSettings( 'selectors' );
		return {
			$app: this.$element.find( selectors.app ),
		};
	}

	bindEvents() {
		let data = JSON.parse(decode(Base64.decode(this.elements.$app[0].getAttribute( 'data')), {level: 'html5'}));
		let json_data = JSON.parse(data);
		ReactDOM.render(<App data={json_data} />, this.elements.$app[0])
	}
}

jQuery( window ).on( 'elementor/frontend/init', () => {

	const addHandler = ( $element ) => {
		elementorFrontend.elementsHandler.addHandler( WidgetContactUs, {
			$element,
		} );
	};

	elementorFrontend.hooks.addAction( 'frontend/element_ready/ecf_contact_us.default', addHandler );
} );

class App extends React.Component {

	constructor(props){
		super(props);
		this.state = {
			data: props.data
			// particulars: {
			// 	title: data.,
			// 	address: {
			// 		title: '',
			// 		gender: '',
			// 		firstname_placeholder: '',
			// 		lastname_placeholder: ''
			// 	},
			// 	contact: {
			// 		title: '',
			// 		email_placeholder: '',
			// 		phone_placeholder: ''
			// 	}
			// },
			// note: {
			// 	title: '',
			// 	subject_placeholder: '',
			// 	message_placeholder: ''
			// },
			// policy: {
			// 	policy_content: '',
			// 	policy_agree: '',
			// 	submit_button: ''
			// },
			// thankYouActive: false
		}
	}

	render() {
		let { data } = this.state;
		return (
			<>
				{ !data.thankYouActive ?
					<>
						{ data.mapActive != 'yes' &&
							<div className="container ecf-contact-us__offset-box">
								<Sections cmsData={data} />
							</div>
						}
						{ data.mapActive == 'yes' &&
							<div className="container ecf-contact-us__map">
								<Map cmsData={data} />
							</div>
						}
					</>
					:
					<>
						<div className="container ecf-contact-us__offset-box">
							<ThankYou cmsData={data.thankYouMessage} />
						</div>
					</>
				}
			</>
		)
	}
}
